import { render } from "./ProductInfoCard.vue?vue&type=template&id=1f017b8c"
import script from "./ProductInfoCard.vue?vue&type=script&lang=js"
export * from "./ProductInfoCard.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__